<template>
  <v-dialog v-model="visible" max-width="550px">
    <v-form v-model="valid" ref="form">
      <v-card :loading="loading">
        <v-card-title>
          Formulir Surat Keluar
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row no-gutters>
              <v-col class="py-1" cols="6">
                <v-menu
                  :disabled="readOnly"
                  close-on-content-click
                  transition="scale-transition"
                  :nudge-right="40"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="model.tgl_surat"
                      label="Tanggal Surat"
                      placeholder="Masukkan Tanggal Surat"
                      prepend-icon="mdi-calendar-range"
                      readonly
                      v-on="on"
                      :error="errors.has('tgl_surat')"
                      :error-messages="errors.get('tgl_surat')"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="model.tgl_surat"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-autocomplete
                  :disabled="readOnly"
                  class="mt-3"
                  prepend-icon="mdi-counter"
                  label="Kode Klasifikasi Surat"
                  placeholder="Cari Kode"
                  v-model="model.kode"
                  item-value="kode"
                  item-text="kode_jenis"
                  :items="kodeSurat"
                  :error="errors.has('kode')"
                  :error-messages="errors.get('kode')"
                  clearable
                  :search-input.sync="kodeSuratQuery"
                  :no-data-text="
                    $store.state.loadingKodeSurat
                      ? 'Mencari Kode Surat...'
                      : 'Tidak Ada Data'
                  "
                  :hide-no-data="!kodeSuratQuery"
                  :loading="$store.state.loadingKodeSurat"
                ></v-autocomplete>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-autocomplete
                  :disabled="readOnly"
                  class="mt-3"
                  prepend-icon="mdi-account"
                  label="Pengolah"
                  placeholder="Pilih Pengolah Surat"
                  v-model="model.bidang_id"
                  item-value="id"
                  item-text="name"
                  :items="$store.state.bidang"
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-text-field
                  :disabled="readOnly"
                  v-model="model.perihal"
                  label="Perihal"
                  prepend-icon="mdi-information"
                ></v-text-field>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-text-field
                  :disabled="readOnly"
                  v-model="model.tujuan"
                  label="Tujuan Surat"
                  prepend-icon="mdi-send"
                ></v-text-field>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-file-input
                  v-if="!readOnly"
                  class="mt-3"
                  v-model="model.lampiran"
                  accept="application/pdf"
                  display-size
                  counter
                  multiple
                  label="Dokumen Surat"
                  placeholder="Pilih Dokumen PDF"
                  prepend-icon="mdi-file-document-outline"
                  :error="errors.has('lampiran')"
                  :error-messages="errors.get('lampiran')"
                ></v-file-input>
              </v-col>
              <v-col class="py-1" cols="12">
                <v-textarea
                  :readonly="readOnly"
                  label="Ringkasan"
                  placeholder="Masukkan Ringkasan Isi Surat"
                  v-model="model.ringkasan"
                  prepend-icon="mdi-information-outline"
                  rows="2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              v-if="!loading"
              @click="visible = false"
            >
              Tutup
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              :loading="loading"
              @click="submit"
            >
              Simpan
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import Errors from '@/utils/errors'
import { mapGetters } from 'vuex'
import { saveSuratKeluar } from '@/services/surat'
import { debounce } from 'lodash'

const initialModel = {
  id: '',
  index_surat: null,
  tgl_surat: moment().format('YYYY-MM-DD'),
  tujuan: '',
  perihal: '',
  bidang_id: '',
  lampiran: null,
  kode: '',
  ringkasan: ''
}

export default {
  name: 'surat-keluar-form',
  data() {
    return {
      visible: false,
      valid: false,
      nonEmptyRule: [v => !!v || 'tidak boleh kosong'],
      nonEmptyFileRule: [value => !value.length == 0 || 'tidak boleh kosong'],
      model: { ...initialModel },
      errors: new Errors(),
      loading: false,
      kodeSuratQuery: ''
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    readOnly() {
      return false
    },
    kodeSurat() {
      return this.$store.state.kodeSurat.data.map(k => ({
        kode: k.kode,
        kode_jenis: k.kode + ' - ' + k.jenis
      }))
    }
  },
  watch: {
    visible: function(val) {
      if (!val) {
        this.reset()
      }
    },
    kodeSuratQuery: debounce(function(val) {
      this.searchKodeSurat(val)
    }, 500)
  },
  methods: {
    searchKodeSurat(q = '') {
      this.$store.dispatch('fetchKodeSurat', q)
    },
    show(model = initialModel) {
      this.searchKodeSurat(model.kode)
      if (model.lampiran && typeof model.lampiran === 'string') {
        model.lampiran = null
      }
      console.log('SHOW SURAT KELUAR', model)
      this.model = { ...model }
      this.visible = true
    },
    load(item) {
      this.model = {
        ...item,
        lampiran: null
      }
    },
    reset() {
      this.$nextTick(() => {
        this.$refs.form.resetValidation()
      })
      this.model = { ...initialModel }
    },
    async submit() {
      const isValid = this.$refs.form.validate()
      if (!isValid) {
        return
      }

      try {
        this.loading = true
        await saveSuratKeluar(this.model)
        this.dialog = false
        this.visible = false
        this.$emit('handle-snackbar', 'Surat berhasil disimpan', 'success')
        this.$emit('submited')
      } catch (error) {
        this.$emit('handle-snackbar', 'Gagal menyimpan surat', 'error')
        if (error.status == 422) {
          this.errors.record(error.data)
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style></style>
